module.exports = __webpack_public_path__ + "media/images/pages/i-belong/gcse_options-3ec26e927fcfa111e1a15b4c56f68aaa.svg";